import { QuestionCategoryMutation } from "./types";
import { MutationTree } from "vuex";
import { AppState } from "./index";
import { QuestionCategory } from "@/global/interfaces";

export const mutations: MutationTree<AppState> = {
  [QuestionCategoryMutation.SET_QUESTION_CATEGORIES](
    state,
    questionCategories: QuestionCategory[],
  ) {
    state.questionCategories = questionCategories;
  },
};
